import Immutable from "immutable";
const baseUrl = process.env.REACT_APP_BACKEND_URL;
export default {
  home: baseUrl + "/api/home?api=3",
  profile: baseUrl + "/api/profil/get?api=3",
  legal: baseUrl + "/api/page/get/legal",
  cookies: baseUrl + "/api/page/get/cookies",
  confidentiality: baseUrl + "/api/page/get/confidentiality",
  login: baseUrl + "/api/auth/login",
  logout: baseUrl + "/api/auth/logout",
  registration: baseUrl + "/api/registration",
  cms: baseUrl + "/api/cms",
  ping: baseUrl + "/api/ping",
  faq: baseUrl + "/api/faq",
  theme: baseUrl + "/api/theme",
  account: baseUrl + "/api/account",
  message: baseUrl + "/api/message",
  orchestrator: baseUrl + "/api/orchestrator",
  quiz: baseUrl + "/api/orchestrator/quiz",
  feedback: baseUrl + "/api/feedback",
  news: baseUrl + "/api/news",
  newsthumbpreview: baseUrl + "/cache/news/{newsId}",
  speedtest: baseUrl + "/api/speedtest",
  stWorker: baseUrl + "/api/st",
  events: baseUrl + "/api/events",
  availableevents: baseUrl + "/api/availableevents",
  myevents: baseUrl + "/api/myevents",
  mypastevents: baseUrl + "/api/mypastevents",
  eventthumbpreview: baseUrl + "/cache/events/{eventId}",
  themethumbpreview: baseUrl + "/cache/themes/{themeId}",
  eventSendInvite: baseUrl + "/api/events/invite",
  eventSubscribe: baseUrl + "/api/events/subscribe",
  eventUnsubscribe: baseUrl + "/api/events/unsubscribe",
  contact: baseUrl + "/api/contact",
  rpwd: baseUrl + "/api/auth/rpwd",
  cpwd: baseUrl + "/api/auth/cpwd",
  fb: "",
  ld: "",
  getJobs: () => {
    if (process.env.REACT_APP_SITE === "psy")
      return [
        { label: "Médecin", value: "md" },
        { label: "Médecin sans RPPS", value: "x2" },
        { label: "Infirmier", value: "in" },
        { label: "Infirmier sans ADELI", value: "x3" },
        { label: "Interne", value: "x1" },
        // { label: "Otsuka-Lundbeck", value: "lb" },
      ];
  },

  getJobsCategories: () => {
    if (process.env.REACT_APP_SITE === "psy")
      return {
        md: "isMd",
        x2: "isX2",
        in: "isIn",
        x3: "isX3",
        x1: "isX1",
        // lb: "isLb",
      };
  },
  getMenu: ($$user, options) => {
    let userRole;
    let userSubRole;
    if ($$user === undefined) userRole = "visitor";
    else {
      userRole = $$user.get("role");
      userSubRole = $$user.get("subRole");
    }
    let menu = [];
    if (userRole === undefined || userRole === "visitor") {
      menu.push({ icon: "home", title: "Accueil", url: "/" });
    } else if (userRole !== "staff") {
      menu.push({ icon: "home", title: "Mes webconférences", url: "/" });
    }
    // if (userRole === 'member' || userRole === 'speaker' || userRole === 'admin') {
    // menu.push({ icon: 'lives', title: 'Live', url: '/live'})
    // menu.push({ icon: 'replays', title: 'Replay', url: '/replays'})
    // }
    // if (userRole !== 'speaker') {
    // menu.push({ icon: 'agenda', title: 'Agenda', url: '/agenda'})
    // }

    if (userRole === "staff") {
      menu.push({
        icon: "event",
        title: "Emissions",
        url: "/staff/event/list",
      });
    }

    menu.push({ icon: "replays", title: "Replays", url: "/replays" });
    menu.push({ icon: "help", title: "Aide", url: "/help" });
    menu.push({ icon: "contact", title: "Contact", url: "/contact" });

    return options !== undefined && options.asImmutable === true
      ? Immutable.fromJS(menu)
      : menu;
  },
  getProfileMenu: ($$user, options) => {
    let userRole;
    let userSubRole;
    if ($$user === undefined) userRole = "visitor";
    else {
      userRole = $$user.get("role");
      userSubRole = $$user.get("subRole");
    }
    let menu = [];
    // if (userRole === 'member')
    // menu.push({ title: 'Mes événements', url: '/my_events'})
    if (
      userRole === "member" ||
      userRole === "speaker" ||
      userRole === "staff" ||
      userRole === "admin"
    )
      menu.push({ title: "Mon compte", url: "/account" });
    // if (userRole === "member")
      // menu.push({ title: "Mes fichiers", url: "/files" });
    if (userRole === "admin") {
      // menu.push({ icon: 'admin', title: 'Admin', url: '/admin'})
      menu.push({
        icon: "account",
        title: "Professionnels",
        url: "/staff/account/list",
      });
      menu.push({ icon: "theme", title: "Thèmes", url: "/staff/theme/list" });
      menu.push({
        icon: "event",
        title: "Emissions",
        url: "/staff/event/list",
      });
      menu.push({ icon: "cms", title: "CMS", url: "/staff/cms/list" });
      menu.push({ icon: "news", title: "News", url: "/staff/news/list" });
      menu.push({ icon: "faq", title: "FAQ", url: "/staff/faq/list" });
      menu.push({
        icon: "message",
        title: "Moderation",
        url: "/staff/orchestrator/list",
      });
      menu.push({
        icon: "email",
        title: "Emails",
        url: "/api/_cron/mail",
        target: "_blank",
      });
      menu.push({
        icon: "logs",
        title: "Logs",
        url: "/api/_logs",
        target: "_blank",
      });
      menu.push({
        icon: "export",
        title: "Exports",
        url: "/api/_exports",
        target: "_blank",
      });
    }
    if (userSubRole === "buadm") {
      menu.push({
        icon: "account",
        title: "Professionnels",
        url: "/staff/account/list",
      });
    }
    if (
      userSubRole === "mod" ||
      userSubRole === "buadm" ||
      userRole === "speaker"
    ) {
      menu.push({
        icon: "moderation",
        title: "Moderation",
        url: "/staff/orchestrator/list",
      });
    }
    if (userSubRole === "buadm") {
      menu.push({
        icon: "export",
        title: "Exports",
        url: "/api/_exports",
        target: "_blank",
      });
    }

    menu.push({ title: "Se déconnecter", url: "/logout" });
    return options !== undefined && options.asImmutable === true
      ? Immutable.fromJS(menu)
      : menu;
  },
};



// WEBPACK FOOTER //
// ./src/config/api.jsx